import axios from 'axios';
import router from '../router/index';
import $ from 'jquery';
import Vue from 'vue';
import { Message } from 'element-ui';
const sponsors = {
    state: () => ({
        items: [],
        filter: {
            searchTerm: null,
            skip: 0,
            take: 1000,
            total: 0,
            page: 1,
        },
        selectedItems: [],
        loading: true,
        categories: [],
    }),
    mutations: {
        setSponsors(state, payload) {
            state.items = payload.items;
            state.filter.total = payload.total;
        },
        setSponsorCategories(state, payload) {
            state.categories = payload.items;
            var categories = [];
            categories = _.sortBy(state.categories, ['orderNO']);
            categories.map((i, index) => {
                categories[index].sponsors = state.items.filter((k) => k.categoryID == i.id);
            });
            state.categories = categories;
        },
        setSelectedSponsors(state, payload) {
            state.selectedItems = payload;
        },
        setSponsorPage(state, payload) {
            state.filter.page = payload;
            this.dispatch('getSponsors');
        },
        setSponsorTake(state, payload) {
            state.filter.page = 1;
            state.filter.take = payload;
            this.dispatch('getSponsors');
        },
    },
    actions: {
        async getSponsors(store) {
            store.state.loading = true;
            var res = await axios.post('sponsor/list', {
                ...store.state.filter,
                skip: (store.state.filter.page - 1) * store.state.filter.take,
            });
            store.state.loading = false;
            var resx = await axios.post('sponsor/listcategories', { skip: 0, take: 1000 });
            store.commit('setSponsors', res.data.data);
            store.commit('setSponsorCategories', resx.data.data);
        },
        async togglesponsors(store, payload) {
            var res = await axios.post('sponsor/toggleisactive', {
                id: store.state.items[payload.index].id,
            });
            return res.data;
        },
        async deleteSponsor(store, payload) {
            var res = await axios.post('sponsor/delete', { id: payload });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
        async getSponsor(store, payload) {
            var res = await axios.post('Sponsor/Get', { id: payload });
            return res;
        },
        async addUpdateSponsor(store, payload) {
            var res = await axios.post('sponsor/addorupdate', payload);
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },

        async getSponsorCategory(store, payload) {
            var res = await axios.post('sponsor/getcategory', { id: payload });
            return res;
        },
        async addUpdateSponsorCategory(store, payload) {
            var res = await axios.post('sponsor/addorupdatecategory', payload);
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
        async deleteSponsorCategory(store, payload) {
            var res = await axios.post('sponsor/deletecategory', { id: payload.id });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
                return false;
            } else {
                Message.success(res.data.alert.message);
                return true;
            }
        },
    },
    getters: {},
};
export default sponsors;


// WEBPACK FOOTER //
// ./src/store/sponsors.js